import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicPartners({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M5 1.55a3.25 3.25 0 012.22 5.623c.952.436 1.709 1.193 2.24 2.19.19-.189.399-.353.624-.492a2.75 2.75 0 113.835-.001c1.3.797 2.031 2.455 2.031 4.515l-.002.057a.75.75 0 01-.646.801l-.102.007H.8a.75.75 0 01-.75-.75l.002-.053a.76.76 0 01-.002-.055c0-2.854 1.04-5.103 2.874-6.093A3.25 3.25 0 015 1.55zm.2 6.7c-2.101 0-3.451 1.73-3.63 4.5h7.26C8.65 9.98 7.3 8.25 5.2 8.25zm6.8 1.6c-.854 0-1.499.4-1.923 1.162.134.542.22 1.124.255 1.738h4.09c-.167-1.809-1.063-2.9-2.422-2.9zm0-4.2a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-7-2.6a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicPartners.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicPartners.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicPartners svgRef={ref} {...props} />);
export default ForwardRef;
